import axios from 'axios'
import  { checkErrorData, checkErrorDataNull } from './authAction'
import  { formatList, capitalize, capitalizeWord, orderByAsc } from './format'

export function newCategory(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_CATEGORY_START", payload: "" })

            console.log("new Category START", {data})
            const res = await axios.post('/categories/new',{data})
            console.log({res});            
                        
            if (checkErrorData(res, "CREATE_CATEGORY_ERROR", dispatch ) ) {
                res.data.category_name = capitalizeWord(res.data.category_name)

				dispatch({ type: "NEW_CATEGORY", payload: res.data })
				dispatch({ type: "CREATE_CATEGORY_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new category ", err);
            dispatch({
                type: "CREATE_CATEGORY_ERROR",
                payload: err
            })
        }
    }
}

export function fetchParentCategories() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_PARENT_CATEGORIES_START", payload: "" })

            console.log("fetch Category START")
            const res = await axios.get('/categories/parent/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_PARENT_CATEGORIES_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_PARENT_CATEGORIES",
                    payload: formatList(orderByAsc(capitalize(res.data, "category_name"), "category_name"), "category_id")
                })
                dispatch({ type: "FETCH_PARENT_CATEGORIES_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get categories list ", err);
            dispatch({ type: "FETCH_PARENT_CATEGORIES_ERROR", payload: err })
        }
    }
}

export function fetchChildCategories() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_CHILD_CATEGORIES_START", payload: "" })

            console.log("fetch Category START")
            const res = await axios.get('/categories/child/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_CHILD_CATEGORIES_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_CHILD_CATEGORIES",
                    payload: formatList(orderByAsc(capitalize(res.data, "category_name"), "category_name"), "category_id")
                })
                dispatch({ type: "FETCH_CHILD_CATEGORIES_FULFILLED", payload: "" })

            } 
        } catch(err) {
            console.log("[ERROR] get categories list ", err);
            dispatch({ type: "FETCH_CHILD_CATEGORIES_ERROR", payload: err })
        }
    }
}
export function refetchCategories() {
    return async function(dispatch){
        try{
            console.log("refetch Category START")
            const resP = await axios.get('/categories/parent/get/all')
            const resC = await axios.get('/categories/child/get/all')
            
            if (!resP.data.error && !resC.data.error ){
                let list = {
                    PARENT: {},
                    CHILD: {},
                    NAMES: {},
                    LIST: {},
                    ALL: {},
                }
                list.PARENT = formatList(orderByAsc(capitalize(resP.data, "category_name"), "category_name"), "category_id")
                
                list.CHILD = formatList(orderByAsc(capitalize(resC.data, "category_name"), "category_name"), "category_id")
                list.NAMES = Object.assign(
                    formatList(orderByAsc(capitalize(resP.data, "category_name"), "category_name"), "category_id"),
                    formatList(orderByAsc(capitalize(resC.data, "category_name"), "category_name"), "category_id")
                )

                Object.values(list.CHILD).forEach( cat => {

                    if(!cat.category_sub_parent){
                        if(list.LIST[cat.category_parent]){
                            list.LIST[cat.category_parent].push(cat.category_id)
                        } else {
                            list.LIST[cat.category_parent] = [cat.category_id]
                        }

                    } else {
                        if(list.LIST[cat.category_sub_parent]){
                            list.LIST[cat.category_sub_parent].push(cat.category_id)
                        } else {
                            list.LIST[cat.category_sub_parent] = [cat.category_id]
                        }
                    }
    
                    if(list.ALL[cat.category_parent]){
                        list.ALL[cat.category_parent].push(cat.category_id)
                    } else {
                        list.ALL[cat.category_parent] = [cat.category_id]
                    }
                })
                dispatch({
                    type: "REFETCH_CATEGORIES",
                    payload: list
                })
            } else {
				console.log("ERROR", resP.data.error, resC.data.error);				
			}
        } catch(err) {
            console.log("[ERROR] refetch categories list ", err);
        }
    }
}
export function toggleCategoryActive(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "TOGGLE_CATEGORY_ACTIVE_START", payload: "" })

            const res = await axios.post("/categories/toggle-active", { data: { category_id: data.category_id, is_active: data.is_active } })
            
            if (checkErrorData(res, "TOGGLE_CATEGORY_ACTIVE_ERROR", dispatch ) ) { 
                dispatch({
                    type: "TOGGLE_CATEGORY_ACTIVE",
                    payload: data
                })
                dispatch({ type: "TOGGLE_CATEGORY_ACTIVE_FULFILLED", payload: "" })
                return { success: true };
            }
            const errPayload = res?.data?.error?.error ?? res?.data?.error ?? "Erreur";
            return { success: false, error: typeof errPayload === "string" ? errPayload : (errPayload?.message || "Erreur") };
        } catch(err) {
            console.log("[ERROR] toggle category active ", err);
            const errMsg = err?.response?.data?.error?.error ?? err?.response?.data?.error ?? err?.message ?? "Erreur";
            dispatch({
                type: "TOGGLE_CATEGORY_ACTIVE_ERROR",
                payload: typeof errMsg === "string" ? errMsg : err
            })
            return { success: false, error: typeof errMsg === "string" ? errMsg : (errMsg?.message || "Erreur") };
        }
    }
}
export function updateCategory(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_CATEGORY_START", payload: "" })

            console.log("update Category START")
            const res = await axios.post("/categories/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_CATEGORY_ERROR", dispatch ) ) { 
                // dispatch(refetchCategories())
                dispatch({
                    type: "UPDATE_CATEGORY",
                    payload: data
                })
                dispatch({ type: "UPDATE_CATEGORY_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update category ", err);
            dispatch({
                type: "UPDATE_CATEGORY_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchParentCategoriesSpent(year) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_PARENT_SPENT_START", payload: "" })

            console.log("fetch Category START")
            const res = await axios.post('/categories/budget/spent', {data: year})
            console.log({res});
            
            if (checkErrorDataNull(res, "FETCH_PARENT_SPENT_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_PARENT_SPENT",
                    payload: formatList(res.data, "category_id")
                })
                dispatch({ type: "FETCH_PARENT_SPENT_FULFILLED", payload: "" })
                
            } 
        } catch(err) {
            console.log("[ERROR] get categories list ", err);
            dispatch({ type: "FETCH_PARENT_SPENT_ERROR", payload: err })
        }
    }
}
export function updateActiveBudget(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_ACTIVE_BUDGET_START", payload: "" })

            console.log("update Category START")
            const res = await axios.post("/categories/budget/update/active", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_ACTIVE_BUDGET_ERROR", dispatch ) ) { 
                dispatch({
                    type: "UPDATE_ACTIVE_BUDGET",
                    payload: data
                })
                dispatch({ type: "UPDATE_ACTIVE_BUDGET_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update category ", err);
            dispatch({
                type: "UPDATE_ACTIVE_BUDGET_ERROR",
                payload: err
                
            })
        }
    }
}
export function fetchBudgets(year) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_BUDGETS_START", payload: "" })

            console.log("update Category START")
            const res = await axios.post("/categories/budget/get/all", {data:year})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_BUDGETS_ERROR", dispatch ) ) { 
                dispatch({
                    type: "GET_BUDGETS",
                    payload: res.data
                })
                dispatch({ type: "FETCH_BUDGETS_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] update category ", err);
            dispatch({
                type: "FETCH_BUDGETS_ERROR",
                payload: err
                
            })
        }
    }
}
export function newBudget(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_BUDGET_START", payload: "" })

            console.log("new budget START")
            const res = await axios.post("/categories/budget/new", {data})
            console.log({res});
            
            if (checkErrorData(res, "CREATE_BUDGET_ERROR", dispatch ) ) { 
                dispatch({
                    type: "NEW_BUDGET",
                    payload: res.data
                })
                dispatch({ type: "CREATE_BUDGET_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] new budget ", err);
            dispatch({
                type: "CREATE_BUDGET_ERROR",
                payload: err
                
            })
        }
    }
}
